import React, { useContext } from 'react';
import AuthContext from '../../../AuthContext';

const reportOptions = [
  { value: '', label: 'Select Report Type' },
  { value: 'invoice', label: 'Invoice' },
  { value: 'ledger', label: 'Ledger' },
  { value: 'summary', label: 'Summary' },
  { value: 'mis', label: 'MIS' },
  { value: 'tc', label: 'TC & Trainer Report' },
];

const ReportTypeDropdown = ({ type, onChange }) => {
  const auth = useContext(AuthContext);

  // Filter report options based on user type
  const filteredReportOptions =
    auth.userType === 'Manager'
      ? reportOptions.filter((option) => option.value !== 'invoice' && option.value !== 'ledger'):
      auth.userType==='Accounts' ?reportOptions.filter((option) => option.value !== 'mis' && option.value !== 'summary'&& option.value !== 'tc')
      : reportOptions;

  return (
    <div>
      <label
        htmlFor="report-type"
        className="block text-gray-700 text-sm font-semibold mb-2"
      >
        Report Type
      </label>
      <select
        id="report-type"
        name="reportType"
        value={type}
        onChange={onChange}
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
      >
        {filteredReportOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ReportTypeDropdown;
